<p-dialog
  [maximizable]="true"
  class="filters-modal"
  header="Nuevo cashout"
  [modal]="true"
  [(visible)]="ctx.showNewTransaction"
  [style]="{ width: '1100px' }"
  *ngIf="ctx.showNewTransaction && ctx.currency == 'MXN'"
  (visibleChange)="ctx.closeAddModal()"
>
  <div
    class="new-transaction-form"
    *ngIf="
      ctx.newTransactionType === 'normal' ||
      ctx.newTransactionType === 'express'
    "
  >
    <div class="form-heading">
      <div class="form-title">Datos del retiro</div>
      <p-button
        *ngIf="ctx.canShowCsvUpload()"
        label="Subida en lotes (.CSV)"
        severity="secondary"
        [outlined]="true"
        (click)="ctx.showCsvUpload()"
      />
    </div>

    <div class="form-scroll-wrapper">
      <form class="form-container" [formGroup]="ctx.newTransactionForm">
        <!-- Fila 1: identificación del cashout + beneficiario + monto -->
        <div class="form-row">
          <div class="filter-column">
            <div class="form-item">
              <label for="mxn_tx_id">ID de la transacción (opcional)</label>
              <input
                id="mxn_tx_id"
                type="number"
                formControlName="transaction_id"
                pInputText
                class="id-input-filter"
              />
            </div>

            <div class="form-item" *ngIf="ctx.auth.hasRole(ctx.roles.Admin)">
              <label for="mxn_client">Cliente asignado</label>
              <p-dropdown
                id="mxn_client"
                formControlName="client_id"
                [options]="ctx.userService.users"
                optionLabel="username"
                [filter]="true"
                filterBy="username"
                appendTo="body"
              />
            </div>

            <div class="form-item" *ngIf="ctx.transactionTypes.length">
              <label>Tipo de transacción</label>
              <div class="account-type-picker">
                <div
                  *ngFor="let type of ctx.transactionTypes"
                  class="accu-type"
                  [class.selected]="
                    ctx.newTransactionForm.controls.transaction_type.value ===
                    type.id
                  "
                  (click)="ctx.setTransactionType(type.id)"
                >
                  {{ type.id }}
                </div>
              </div>
            </div>
          </div>

          <div class="filter-column">
            <div class="form-item">
              <label for="mxn_firstname">Nombre(s) beneficiario</label>
              <input
                id="mxn_firstname"
                type="text"
                formControlName="firstname"
                pInputText
                class="id-input-filter"
              />
            </div>
            <div class="form-item">
              <label for="mxn_lastname">Apellidos beneficiario</label>
              <input
                id="mxn_lastname"
                type="text"
                formControlName="lastname"
                pInputText
                class="id-input-filter"
              />
            </div>
          </div>

          <div class="filter-column">
            <div class="form-item">
              <label for="mxn_amount">Monto (MXN)</label>
              <input
                id="mxn_amount"
                type="number"
                placeholder="Ej. 1500.50"
                formControlName="amount"
                pInputText
                class="id-input-filter"
              />
            </div>
          </div>
        </div>

        <!-- Fila 2: SPEI Bitso repartido en 3 columnas -->
        <div class="form-row" formGroupName="bitso_mxn">
          <div class="filter-column">
            <div class="form-item">
              <label for="mxn_protocol">Protocolo SPEI</label>
              <p-dropdown
                id="mxn_protocol"
                formControlName="protocol"
                [options]="bitsoMxProtocolOptions"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
                (onChange)="onBitsoMxProtocolChange()"
              />
            </div>
            <div class="form-item">
              <label for="mxn_clabe">{{ bitsoMxClabeLabel }}</label>
              <input
                id="mxn_clabe"
                type="text"
                [placeholder]="bitsoMxClabePlaceholder"
                formControlName="clabe"
                pInputText
                class="id-input-filter"
                autocomplete="off"
              />
            </div>
            <div
              class="form-item"
              *ngIf="
                ctx.newTransactionForm.get('bitso_mxn')?.get('protocol')
                  ?.value === 'debitcard' ||
                ctx.newTransactionForm.get('bitso_mxn')?.get('protocol')
                  ?.value === 'phonenum'
              "
            >
              <label for="mxn_inst">Código de institución (banco)</label>
              <input
                id="mxn_inst"
                type="text"
                placeholder="Ej. 40002"
                formControlName="institution_code"
                pInputText
                class="id-input-filter"
                autocomplete="off"
              />
            </div>
          </div>

          <div class="filter-column">
            <div class="form-item">
              <label for="mxn_rfc">RFC (opcional recomendado)</label>
              <input
                id="mxn_rfc"
                type="text"
                placeholder="Ej. PESJ590317IG4"
                formControlName="rfc"
                pInputText
                class="id-input-filter"
                autocomplete="off"
              />
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="buttons-container">
      <p-button
        label="Cancelar"
        severity="danger"
        (click)="ctx.exitNewTransaction()"
      />
      <p-button
        label="Guardar cashout"
        [disabled]="ctx.newTransactionForm.invalid || ctx.addingTransaction"
        [loading]="ctx.addingTransaction"
        severity="secondary"
        (click)="saveTransaction()"
      />
    </div>
  </div>

  <div class="new-transaction-form" *ngIf="ctx.newTransactionType === 'csv'">
    <div class="form-heading">
      <div class="form-title">
        Selecciona el archivo .csv que contiene los cashouts a agregar
      </div>
      <a
        class="csv-template-link"
        [href]="'/csv/cashout/' + ctx.currency + '.csv'"
        [download]="ctx.currency + '.csv'"
      >
        Descargar plantilla CSV
      </a>
    </div>
    <div class="picker">
      <input
        id="cashout_csv_file_mxn"
        class="csv-file-input"
        type="file"
        accept=".csv"
        (change)="ctx.onFileSelected($event)"
      />
      <label class="csv-upload-box" for="cashout_csv_file_mxn">
        <span class="csv-upload-icon">
          <i class="pi pi-upload"></i>
        </span>
        <span class="csv-upload-copy">
          <span class="csv-upload-title">
            {{ ctx.selectedFile?.name || "Selecciona tu archivo CSV" }}
          </span>
          <span class="csv-upload-subtitle">
            {{
              ctx.selectedFile
                ? "Archivo listo para subir"
                : "Solo archivos .csv"
            }}
          </span>
        </span>
      </label>
      <div class="picker-actions">
        <p-button
          label="Volver al formulario"
          severity="secondary"
          [outlined]="true"
          (click)="ctx.showCashoutForm()"
        />
        <p-button
          label="Subir archivo"
          [disabled]="!ctx.selectedFile"
          [loading]="ctx.uploadingCSV"
          severity="secondary"
          (click)="ctx.uploadFile()"
        />
      </div>
    </div>
  </div>
</p-dialog>
